import * as React from 'react';
import { observer } from 'mobx-react';
import { ComponentPriceListPageStore } from './ComponentPriceListPageStore';
import { LoaderBox } from '../../components/LoaderBox';
import { Button, Col, Row, Layout, Affix } from 'antd';
import { CurrentCampaignTitle } from '../../components/CurrentCampaignTitle';
import { FilterOutlined } from '@ant-design/icons';
import { ComponentPriceListTable } from './ComponentPriceListTable';
import { ComponentPriceListTools } from './ComponentPriceListTools';
import { ComponentPriceListAddNewLine } from './ComponentPriceListAddNewLine';
import { ComponentPriceListFilterForm } from './ComponentPriceListFilterForm';

const pageStore = new ComponentPriceListPageStore();

export const ComponentPriceListPage: React.FC = observer(() => {
  React.useEffect(() => {
    pageStore.init();
  }, []);

  return (
    <LoaderBox store={pageStore}>
      <Row align='middle'>
        <Col flex='auto'>
          <h1>
            Component Price List <CurrentCampaignTitle />
          </h1>
        </Col>
        <Col>
          <ComponentPriceListTools store={pageStore} />
          <Button
            onClick={() => pageStore.toggleFilter()}
            icon={<FilterOutlined />}
            title='Filters'
            type={pageStore.isFilterUsed ? 'primary' : 'default'}
          />
        </Col>
      </Row>
      <Layout>
        <Layout.Content>
          <ComponentPriceListTable store={pageStore} />
        </Layout.Content>
        <Affix>
          <Layout.Sider
            collapsible
            collapsedWidth={0}
            trigger={null}
            collapsed={!pageStore.isFilterOpen}
            width={300}
          >
            <ComponentPriceListFilterForm store={pageStore} />
          </Layout.Sider>
        </Affix>
      </Layout>
      <ComponentPriceListAddNewLine store={pageStore} />
    </LoaderBox>
  );
});
